import { Injectable } from '@angular/core';
import { Location } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class UsernameService {
  constructor(private location: Location) {}

  getUsername(): string {
    const pathSegments = this.location.path().split('/');
    const usernamePathIndex = pathSegments.length - 1;
    return pathSegments[usernamePathIndex];
  }
}
